import { render, staticRenderFns } from "./EvaluateTab.vue?vue&type=template&id=71e6e7e3"
import script from "./EvaluateTab.vue?vue&type=script&lang=js"
export * from "./EvaluateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports